// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__HThn0","row":"Node_row__38LUE","label":"Node_label__1pYl0","footer":"Node_footer__33gJ1"};